import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "row text-info" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "input-group-addon bg-3"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["aria-expanded"]
const _hoisted_9 = {
  key: 0,
  class: "dropdown-menu dropdown-menu-right"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "input-group-btn"
}
const _hoisted_12 = { class: "row keySelector" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = {
  class: "keySelector-button-group",
  style: {"margin-bottom":"1em"}
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "loading-area text-info",
  style: {"width":"100%","height":"200px","padding":"50px","background-color":"#eee"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "table table-hover table-condensed"
}
const _hoisted_21 = {
  colspan: "2",
  class: "text-strong"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  title: "This path contains a private key that can be used for remote node execution."
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 2,
  title: "This path contains a password that can be used for remote node execution."
}
const _hoisted_28 = { "data-testid": "created-key" }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "text-strong" }
const _hoisted_31 = { class: "pull-right" }
const _hoisted_32 = {
  key: 0,
  title: "This path contains a private key that can be used for remote node execution."
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 2,
  title: "This path contains a password that can be used for remote node execution."
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "text-info" }
const _hoisted_39 = { class: "modal-footer" }
const _hoisted_40 = {
  key: 1,
  class: "row"
}
const _hoisted_41 = { class: "col-sm-12" }
const _hoisted_42 = { class: "well" }
const _hoisted_43 = { class: "text-success" }
const _hoisted_44 = ["aria-label"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "timeabs text-strong" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "text-strong" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "timeago text-strong" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "text-strong" }
const _hoisted_53 = {
  key: 2,
  class: "pull-right"
}
const _hoisted_54 = ["href"]
const _hoisted_55 = {
  key: 3,
  class: "pull-right"
}
const _hoisted_56 = { class: "card-footer" }
const _hoisted_57 = { class: "text-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.errorMsg !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group col-sm-12", [_ctx.invalid === true ? 'has-error' : '']])
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.staticRoot)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.rootPath), 1)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputPath) = $event)),
                type: "text",
                class: "form-control bg-2",
                style: {"padding-left":"18px"},
                placeholder: _ctx.$t('storage.enter.path'),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.loadDirInputPath()), ["enter"]))
              }, null, 40, _hoisted_7), [
                [_vModelText, _ctx.inputPath]
              ]),
              (!_ctx.isProject && !_ctx.readOnly)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["input-group-btn", 
                  _ctx.isDropdownOpen ? 'open input-group-btn' : 'input-group-btn'
                ])
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-default dropdown-toggle",
                      "aria-expanded": _ctx.isDropdownOpen,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.linksTitle), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "caret" }, null, -1))
                    ], 8, _hoisted_8),
                    (_ctx.isDropdownOpen)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jumpLinks, (link) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: link.path
                            }, [
                              _createElementVNode("a", {
                                href: "#",
                                "data-testid": "load-dir-link",
                                onClick: ($event: any) => (_ctx.loadDir(link.path))
                              }, _toDisplayString(link.name), 9, _hoisted_10)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.isRunner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-default",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadDir(_ctx.path, true)))
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("span", null, _toDisplayString("Reload"), -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-default",
                disabled: _ctx.upPath === '',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadDir(_ctx.upPath)))
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "glyphicon glyphicon-folder-open" }, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "glyphicon glyphicon-arrow-up" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.showUpPath()), 1)
              ], 8, _hoisted_15),
              (!_ctx.readOnly || _ctx.allowUpload === true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-cta",
                    "data-testid": "add-key-btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.actionUpload && _ctx.actionUpload(...args)))
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "glyphicon glyphicon-plus" }, null, -1),
                    _createTextVNode(" Add or Upload a Key ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (
                  _ctx.allowUpload === true && _ctx.isSelectedKey === true && !_ctx.readOnly
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-sm btn-warning",
                    "data-testid": "overwrite-key-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.actionUploadModify && _ctx.actionUploadModify(...args)))
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "glyphicon glyphicon-pencil" }, null, -1),
                    _createTextVNode(" Overwrite Key ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (
                  _ctx.selectedKey && _ctx.selectedKey.path && _ctx.isSelectedKey && !_ctx.readOnly
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-sm btn-danger",
                    "data-testid": "delete-key-btn",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteKey && _ctx.deleteKey(...args)))
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "glyphicon glyphicon-trash" }, null, -1),
                    _createTextVNode(" " + _toDisplayString("Delete"), -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[19] || (_cache[19] = _createElementVNode("i", { class: "glyphicon glyphicon-time" }, _toDisplayString("Loading..."), -1)),
                  (_ctx.isRunner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_ctx.countDownLimit > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Reload from the remote Runner in " + _toDisplayString(_ctx.countDownLimit) + " seconds ", 1))
                          : _createCommentVNode("", true),
                        (_ctx.countDownLimit === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Reload "))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_21, [
                        (_ctx.files.length < 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "No keys"))
                          : _createCommentVNode("", true),
                        (_ctx.files.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.files.length), 1),
                              _cache[20] || (_cache[20] = _createTextVNode(" keys ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (key) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: key.name,
                        class: _normalizeClass([
                    _ctx.selectedKey && key.path === _ctx.selectedKey.path
                      ? _ctx.selectedClass
                      : '',
                    'action',
                  ]),
                        onClick: ($event: any) => (_ctx.selectKey(key))
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("i", {
                            class: _normalizeClass([
                        key.path === _ctx.selectedKey.path
                          ? 'glyphicon glyphicon-ok'
                          : 'glyphicon glyphicon-unchecked',
                      ])
                          }, null, 2),
                          (_ctx.isPrivateKey(key))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("i", { class: "glyphicon glyphicon-lock" }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_ctx.isPublicKey(key))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "glyphicon glyphicon-eye-open" }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_ctx.isPassword(key))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "glyphicon glyphicon-lock" }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(key.name), 1),
                          (key.expired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString("[CACHE EXPIRED]")))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, [
                            (_ctx.isPrivateKey(key))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Private Key "))
                              : _createCommentVNode("", true),
                            (_ctx.isPublicKey(key))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, " Public Key "))
                              : _createCommentVNode("", true),
                            (_ctx.isPassword(key))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, " Password "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 10, _hoisted_24))
                    }), 128))
                  ]),
                  (_ctx.notFound() === true)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_35, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", { colspan: "2" }, [
                            _createElementVNode("span", { class: "text-strong" }, "Nothing found at this path. ")
                          ])
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directories, (directory) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: directory.name
                      }, [
                        _createElementVNode("td", {
                          "data-testid": "keyDirectoryButton",
                          class: "action",
                          colspan: "2",
                          onClick: ($event: any) => (_ctx.loadDir(directory.path))
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("i", { class: "glyphicon glyphicon-arrow-down" }, null, -1)),
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "glyphicon glyphicon-folder-close" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.dirNameString(directory.path)), 1)
                        ], 8, _hoisted_36)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isConfirmingDeletion === true)
          ? (_openBlock(), _createBlock(_component_modal, {
              key: 0,
              id: "storagedeletekey",
              ref: "modalDelete",
              modelValue: _ctx.isConfirmingDeletion,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isConfirmingDeletion) = $event)),
              title: "Delete Selected Key",
              "auto-focus": "",
              "append-to-body": "",
              footer: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                  _cache[27] || (_cache[27] = _createElementVNode("p", null, _toDisplayString("Really delete the selected key at this path?"), -1)),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_38, _toDisplayString(_ctx.selectedKey.path), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    type: "button",
                    "data-testid": "confirm-delete-btn",
                    class: "btn btn-sm btn-danger obs-storagedelete-select",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteKey && _ctx.confirmDeleteKey(...args)))
                  }, _toDisplayString("Delete")),
                  _createElementVNode("button", {
                    type: "button",
                    class: "pull-right btn btn-sm btn-default",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteKey && _ctx.cancelDeleteKey(...args)))
                  }, _toDisplayString("Cancel"))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.isSelectedKey && _ctx.selectedKey.type === 'file')
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", null, [
                    _cache[29] || (_cache[29] = _createTextVNode(" Storage path: ", -1)),
                    _createElementVNode("code", _hoisted_43, _toDisplayString(_ctx.selectedKey.path), 1),
                    _createElementVNode("a", {
                      href: "#",
                      "data-bind": "attr: { href: selectedPathUrl() }",
                      "aria-label": _ctx.$t('storage.path.link.label')
                    }, [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("i", { class: "glyphicon glyphicon-link" }, null, -1)
                    ]))], 8, _hoisted_44)
                  ]),
                  (_ctx.createdTime !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", null, [
                          _cache[31] || (_cache[31] = _createTextVNode(" Created: ", -1)),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.formatKeyStorageCreatedTime), 1),
                          (_ctx.createdUsername() !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                _cache[30] || (_cache[30] = _createTextVNode(" by: ", -1)),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.createdUsername()), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.wasModified() !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("div", null, [
                          _cache[33] || (_cache[33] = _createTextVNode(" Modified: ", -1)),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.formatHumanizedModifiedTimeAgoDuration) + " ago ", 1),
                          (_ctx.modifiedUsername() !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                _cache[32] || (_cache[32] = _createTextVNode(" by: ", -1)),
                                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.modifiedUsername()), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedKey && _ctx.isPublicKey(_ctx.selectedKey))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            href: _ctx.downloadUrl()
                          }, [...(_cache[34] || (_cache[34] = [
                            _createElementVNode("i", { class: "glyphicon glyphicon-download" }, null, -1),
                            _createTextVNode(" " + _toDisplayString("Download"), -1)
                          ]))], 8, _hoisted_54)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedKey && _ctx.selectedKey.expired)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            href: 'javascript:void(0)',
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadKeys(_ctx.selectedKey)))
                          }, [...(_cache[35] || (_cache[35] = [
                            _createElementVNode("i", { class: "glyphicon glyphicon-download" }, null, -1),
                            _createTextVNode(" " + _toDisplayString("Refresh Expired Key"), -1)
                          ]))])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_56, [
        _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t(
              "Key Storage provides a global directory-like structure to save Public and Private Keys and Passwords, for use with Node Execution authentication.",
            )), 1)
      ])
    ])
  ]))
}